export default __webpack_public_path__ + "static/media/darktemplar.d157dd7a.png";